import Mixpanel from 'mixpanel-browser';

enum EventNameList {
  CallHistorySearchClicked = 'Call History Search',
  CallFiltersClicked = 'Call Filters Click',
  TeamsButtonClicked = 'Teams Button Click',
  DialerClicked = 'Dialer Click',
  DialerChangeCallerID = 'Dialer Change Caller ID',
  ChangeCountry = 'Change Country',
  ContactsClicked = 'Contacts Click',
  AddAContact = 'Add a contact',
  ContactSearchClicked = 'Contact Search',
  AccountClicked = 'Account Clicked',
  SettingsChangeCallerID = 'Settings Change Caller ID',
  ChangeLanguage = 'Change Language',
  AudioDeviceClicked = 'Audio Device',
  SoundsClicked = 'Sounds',
  GetHelpClicked = 'Get Help',
  TransferButtonClicked = 'Transfer Button',
  InCallTagClicked = 'In Call Tag',
  InCallNotesClicked = 'In Call Notes',
  ConferenceButtonClicked = 'Conference button',
  InCallKeypadClicked = 'In call keypad',
  AnnouncementButtonClicked = 'Announcement button',
  // Tracking the clicks on the "Voice Settings" link of the no-microphone-audio warning
  MicAudioWarningClicked = 'Mic Audio Warning Voice Settings',
  InCallAddAContactClicked = 'In call Add a contact',
  PlayCallRecording = 'Play Call recording',
  HistoryAddTagClicked = 'History: Add Tag',
  HistoryAddNoteClicked = 'History: Add Note',
  SignOutClicked = 'Sign Out',
  QueuesClicked = 'Queues Clicked',
  // Tracking the clicks on the Messages menu item
  ConversationsClicked = 'Messages Click',
  // Tracking the clicks on sending a new message button
  NewSMSClicked = 'NewSMS Click',
  // Tracking the clicks on sending a message
  SendSMSClicked = 'SendSMS Click',
}

export const eventNames = EventNameList;

/**
 * @description Track a named event. The selector picks a member off the enum, so the label sent
 * to Mixpanel is the enum's VALUE - `events.AudioDeviceClicked` sends `'Audio Device'`.
 *
 * The return type used to be `keyof typeof eventNames`, i.e. the member NAME rather than its
 * value, which described neither what callers pass nor what is tracked. Every call site was in a
 * `.js` file, so nothing ever type-checked it; the first TypeScript caller failed to compile.
 * @param eventSelector
 */
const eventTracker = (
  eventSelector: (events: typeof eventNames) => EventNameList
) => {
  Mixpanel.track(eventSelector(eventNames));
};

export default eventTracker;
